import { AbstractControl } from "@angular/forms";

export class PatchDeltaObjectUtility {
	public static getDeltaObject<T>(controls: Record<string, AbstractControl>): Partial<T> {
		const jobPatch = {} as T;
		const keyValueArray = Object.entries(controls).filter(value => value[1].dirty);

		if (keyValueArray.length === 0)
			return null;

		keyValueArray.forEach(kvp => {
			jobPatch[kvp[0]] = kvp[1].value;
		});

		return jobPatch;
	}
}
